import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { HONEYPOT_NAMES } from '../types/honeypot';
import { Header } from '../components/Header';
import './SettingsPage.css';

export const SettingsPage = () => {
  const { siteConfig, user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="settings-page">
      {/* Animated Background */}
      <div className="settings-background">
        <div className="bg-gradient-1"></div>
        <div className="bg-gradient-2"></div>
        <div className="bg-gradient-3"></div>
      </div>

      {/* Header */}
      <Header
        title="Settings"
        subtitle="Manage your account and configuration"
        showBackButton={true}
      />

      {/* Container */}
      <div className="settings-container">
        <div className="settings-card">
          <div className="card-header">
            <h2>👤 User Information</h2>
            <p>Your account details</p>
          </div>
          <div className="card-body">
            <div className="info-row">
              <label>Name:</label>
              <span>{user?.name}</span>
            </div>
            <div className="info-row"><label>Email:</label>
              <span>{user?.email}</span>
            </div>
          </div>
        </div><div className="settings-card">
          <div className="card-header">
            <h2>🍯 Honeypot Configuration</h2>
            <p>Your active site protection and honeypot deployments</p>
          </div>
          <div className="card-body">
            {siteConfig ? (
              <div className="config-preview">
                <div className="info-row">
                  <label>Site URL:</label>
                  <span>{siteConfig.siteUrl}</span>
                </div>
                <div className="info-row">
                  <label>Backend URL:</label>
                  <span>{siteConfig.backendUrl}</span>
                </div>
                <div className="info-row">
                  <label>Description:</label>
                  <span>{siteConfig.siteDescription}</span>
                </div>
                {siteConfig.selectedHoneypots && siteConfig.selectedHoneypots.length > 0 && (
                  <div className="info-row">
                    <label>Active Honeypots:</label>
                    <div className="honeypot-tags">
                      {siteConfig.selectedHoneypots.map((id) => {
                        const honeypot = HONEYPOT_NAMES[id as keyof typeof HONEYPOT_NAMES];
                        return honeypot ? (
                          <span key={id} className="honeypot-tag">
                            {honeypot.icon} {honeypot.name}
                          </span>
                        ) : null;
                      })}
                    </div>
                  </div>
                )}
                <button
                  onClick={() => navigate('/honeypot-config')}
                  className="configure-button"
                >
                  🎯 Modify Honeypot Configuration
                </button>
              </div>
            ) : (
              <div className="no-config">
                <div className="warning-icon">⚠️</div>
                <h3>No Configuration Found</h3>
                <p>You need to configure your site and select honeypots before accessing the dashboard.</p>
                <button
                  onClick={() => navigate('/honeypot-config')}
                  className="configure-button primary"
                >
                  🚀 Configure HoneyCipher
                </button>
              </div>
            )}
          </div>
        </div><div className="settings-card">
          <div className="card-header">
            <h2>⚡ Quick Actions</h2>
            <p>Navigate to different sections of the application</p>
          </div>
          <div className="card-body">
            <div className="action-buttons">
              <button
                onClick={() => navigate('/')}
                className="action-button"
              >
                📊 Go to Dashboard
              </button>
              <button
                onClick={() => navigate('/honeypot-config')}
                className="action-button"
              >
                🎯 Honeypot Configuration
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>);
};